<script lang="ts">
	import { Container, Text, Icon } from '@Shelly/shelly-design-system';

	export let icon = '';
	export let text = '',
		disabled = false,
		element: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'p' | 'span' = 'span',
		container_class = 'd-flex align-items-center mt-s', //'d-inline-flex mt-m',
		icon_class = '', //'mr-s',
		text_class = 'ml-xs',
		size: 'xs' | 's' | 'm' | 'l' | 'xl' = 's';

	let class_disabled = 'text-color-3';
</script>

<div class={container_class}>
	<Icon {icon} {size} class={`${disabled ? class_disabled : ''} ${icon_class}`} />

	<Text styleType="body-small" {element} class={`${disabled ? class_disabled : ''} ${text_class}`}>
		{text}
	</Text>
</div>
